// Device-level push notification state kept in localStorage. Storage can be
// unavailable (private mode, blocked site data), so every access is guarded —
// missing values just fall back to defaults.
const FCM_FID_KEY = 'fcmFid';
const FCM_PROMPT_SNOOZED_UNTIL_KEY = 'fcmPromptSnoozedUntil';

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string | null) {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    // ignore
  }
}

/** The FID last registered with the backend, so it can be unregistered later. */
export const getStoredFcmFid = () => read(FCM_FID_KEY);
export const setStoredFcmFid = (fid: string) => write(FCM_FID_KEY, fid);
export const clearStoredFcmFid = () => write(FCM_FID_KEY, null);

/** "Not now" on the enable-notifications prompt hides it until this time. */
export const isFcmPromptSnoozed = () =>
  Number(read(FCM_PROMPT_SNOOZED_UNTIL_KEY) ?? 0) > Date.now();
export const snoozeFcmPrompt = (ms: number) =>
  write(FCM_PROMPT_SNOOZED_UNTIL_KEY, String(Date.now() + ms));
